import { render, staticRenderFns } from "./OwnerSelection.vue?vue&type=template&id=81f63b5c&scoped=true&"
import script from "./OwnerSelection.vue?vue&type=script&lang=js&"
export * from "./OwnerSelection.vue?vue&type=script&lang=js&"
import style0 from "./OwnerSelection.vue?vue&type=style&index=0&id=81f63b5c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81f63b5c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
